import { ChangeDetectionStrategy, Component, effect, inject, Input, signal, WritableSignal } from '@angular/core';
import { MenuActions } from '../../../states/menu_actions';
import { ShoppingCartState } from '../../../states/shopping-cart-state';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-main-menu-shopping-cart-buton',
  imports: [NgClass],
  templateUrl: './main-menu-shopping-cart-buton.component.html',
  styleUrl: './main-menu-shopping-cart-buton.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainMenuShoppingCartButonComponent {
  @Input() label = '';
  menuActions = inject(MenuActions);
  private shoppingCartState = inject(ShoppingCartState);
  protected shoppingCartItemsCount: WritableSignal<number> = signal(0);
  constructor() {
    effect(() => {
      this.listenForShoppingCartChanges();
    });
  }
  navigateToShoppingCart(): void {
    this.menuActions.navigateToShoppingCart();
  }

  listenForShoppingCartChanges(): void {
    this.shoppingCartItemsCount.set(this.shoppingCartState.shoppingCartItemsCount());
  }
}
